import { useEventSettings } from '../events/useEventSettings';

export function useEventMeetingsEnabled(eventId) {
    const settings = useEventSettings(eventId);
    return !settings?.disable_meetings;
}
